import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { FiltersGroupComponent } from 'src/app/shared/components/filters/filters-group/filters-group.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';

@Component({
  selector: 'app-elaborazione-select',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FiltersGroupComponent,
    MatFormFieldModule,
    MatSelectModule
  ],
  templateUrl: './elaborazione-select.component.html',
  styleUrl: './elaborazione-select.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ElaborazioneSelectComponent {
  @Input() form!: FormGroup;
  @Input() title!: string;
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() optionsValue: Array<string> = [];

}